import userService from '@/api/userService';
import { useUserStore } from '@/store/useUserStore';
import Keycloak, { KeycloakConfig } from 'keycloak-js';

export default function useKeycloak(callBackFunction: () => void) {
	const keycloakConfig: KeycloakConfig = {
		url: process.env.VUE_APP_KEYCLOAK_URL,
		realm: process.env.VUE_APP_KEYCLOAK_REALM,
		clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
	};

	const keycloak = new Keycloak(keycloakConfig);

	function setTokenValue() {
		const accessToken = keycloak.token;

		if (accessToken) {
			localStorage.setItem('keycloak-access-token', accessToken);
		}
	}

	function setupTokenRefreshInterval() {
		setInterval(() => {
			keycloak
				.updateToken(70)
				.then((refreshed) => {
					if (refreshed) {
						const oldToken = localStorage.getItem('keycloak-access-token');
						setTokenValue();

						if (oldToken) {
							userService.refresh(oldToken).catch((error) => {
								console.error('Failed to refresh token on server:', error);
							});
						}
					}
				})
				.catch(() => {
					localStorage.removeItem('keycloak-access-token');
					keycloak.logout();
				});
		}, 60 * 1000);
	}

	async function prepareApp() {
		const { loginUser } = useUserStore();
		setTokenValue();
		await loginUser();
		callBackFunction();
	}

	keycloak
		.init({
			onLoad: 'login-required',
			redirectUri: process.env.VUE_APP_KEYCLOAK_REDIRECT_URI,
			checkLoginIframe: false,
		})
		.then(async (authenticated) => {
			if (!authenticated) {
				return keycloak.login();
			}

			setupTokenRefreshInterval();
			await prepareApp();
		})
		.catch((error) => {
			console.error('Keycloak init failed:', error);
			window.location.reload();
		});

	return keycloak;
}
